
import {defineComponent, PropType} from 'vue'
import {UtilityHelper} from "@/helpers/UtilityHelper";
import InputSelect from "@/components/UI/InputSelect.vue";
import {FullNamedTextFragmentRestDto} from "@/api/pharma-pim-mgmt/models";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";
import {EnumClassNamePimEnum} from "@/models/enum/EnumClassNamePimEnum";
import {NamedTextFragmentRestDtoModel} from "@/models/api/pharma-pim-mgmt/NamedTextFragmentRestDtoModel";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import {AutoSaveFeedbackStatusEnum} from "@/models/enum/AutoSaveFeedbackStatusEnum";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "NamedTextFragmentPanel",
  emits: ["submitNamedFragmentContent", "submitNamedFragmentCancel"],
  components: {GenericFormWrapper, InputTextEditor, InputSelect},
  props: {
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    namedTextFragment: {
      type: Object as PropType<FullNamedTextFragmentRestDto>,
      required: false
    },
  },
  data() {
    return {
      localNamedTextFragment: NamedTextFragmentRestDtoModel.createWithDefaults(),
      originalContent: '' as string,
      enumFragmentNameCode: [] as CodeDescriptionRestDto[],
    }
  },
  watch: {
    namedTextFragment: {
      handler() {
        this.reloadContent();
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper
    },
  },
  methods: {
    async initialize(): Promise<void> {
      this.enumFragmentNameCode = await EnumRestService.getInstance()
        .getEnumValuesByClassName(EnumClassNamePimEnum.TEXT_FRAGMENT_NAME, DpModuleEnum.CPC);
      this.reloadContent();
    },
    reloadContent(): void {
      if (this.namedTextFragment !== null && this.namedTextFragment !== undefined) {
        this.localNamedTextFragment = new NamedTextFragmentRestDtoModel(
          this.namedTextFragment?.text_fragment?.code ?? '',
          this.namedTextFragment?.text_fragment?.fragment?.content ?? null
        );
        this.originalContent = this.namedTextFragment.text_fragment.fragment?.content ?? '';
      } else {
        this.originalContent = '';
      }
      this.checkFormDataChanged();
    },
    checkFormDataChanged(): void {
      if (this.localNamedTextFragment.fragment?.content === this.originalContent) {
        this.pageUI.setAutoSaveFeedbackStatus(AutoSaveFeedbackStatusEnum.NONE);
        this.pageUI.setCanSubmit(false);
      } else {
        this.pageUI.setAutoSaveFeedbackStatus(AutoSaveFeedbackStatusEnum.UNSAVED_CHANGES);
        this.pageUI.setCanSubmit(true);
      }
    },
    submitNamedFragmentContent(): void {
      this.$emit('submitNamedFragmentContent', this.namedTextFragment?.id ?? null, this.localNamedTextFragment);
    },
    submitNamedFragmentCancel(): void {
      this.$emit('submitNamedFragmentCancel', this.namedTextFragment?.id ?? null);
    },
  }
})
